import React, { useState } from 'react'
import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { Mask } from '../../../hooks/Mask'
const Tab = styled.button`
  font-size: 17px;
  padding: 10px 5vw;
  cursor: pointer;
  opacity: 0.6;

  border:1px
  border: 0;
  outline: 0;
  color: ${({ theme }) => theme.primary};
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid ${color.brand};
    opacity: 1;
  `}
`
const ButtonGroup = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
`

const Total = styled.p`
  font-size: 23px;
  span {
    font-weight: bold;
    margin-left: 4px;
  }
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
`

const types = ['MÉTODOS', 'APP', 'DAS']
const TabGroup = ({ setTab, info }) => {
  const [active, setActive] = useState(types[0])
  return (
    <>
      <ButtonGroup>
        {types.map((type, index) => (
          <Tab
            key={type}
            active={active === type}
            onClick={() => {
              setActive(type), setTab(index + 1)
            }}
          >
            {type}
          </Tab>
        ))}
        {info ? (
          <Total>
            Total: <span>{Mask.percent(info)}</span>
          </Total>
        ) : null}
      </ButtonGroup>

      <p />
      <hr></hr>
    </>
  )
}

export default TabGroup
